import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map_distance",
  "use": "icon-map_distance-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-map_distance\">\n<g id=\"icon-map_distance_surface1\">\n<path style=\" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.335938 1.160156 C 2.253906 4 -1.726563 18.242188 8 14.824219 C 15.898438 12.050781 15.980469 -2.367188 8.335938 1.160156 M 11 2 C 8.460938 5.605469 5.605469 8.460938 2 11 C 3.976563 6.765625 6.765625 4 11 2 M 13 4 C 13 9.097656 9 13.074219 4 13 C 5.363281 11.179688 5.492188 12 5 10 C 6.414063 10.472656 6.8125 10.8125 8 12 L 8 8 L 11 9 L 10 5 C 11.414063 5.472656 11.8125 5.8125 13 7 C 12.785156 5.578125 12.726563 5.328125 13 4 \" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/map/map_distance.svg
// module id = v2ZU
// module chunks = 24